/* This file is automatically generated for @graphcommerce/magento-product */

export * from '.'
import { Plugin as GaAddProductsToCartForm } from '@graphcommerce/googleanalytics/plugins/GaAddProductsToCartForm'
import { Plugin as GaProductListItem } from '@graphcommerce/googleanalytics/plugins/GaProductListItem'
import { Plugin as GaProductListItemsBase } from '@graphcommerce/googleanalytics/plugins/GaProductListItemsBase'
import { Plugin as GaViewItem } from '@graphcommerce/googleanalytics/plugins/GaViewItem'
import { ComponentProps } from 'react'
import { 
  AddProductsToCartForm as AddProductsToCartFormBase,
  ProductListItem as ProductListItemBase,
  ProductListItemsBase as ProductListItemsBaseBase,
  ProductPageMeta as ProductPageMetaBase,
} from '.'

/**
 * Interceptor for `<AddProductsToCartForm/>` with these plugins:
 * 
 * - `@graphcommerce/googleanalytics/plugins/GaAddProductsToCartForm`
 */
type AddProductsToCartFormProps = ComponentProps<typeof AddProductsToCartFormBase>

function GaAddProductsToCartFormInterceptor(props: AddProductsToCartFormProps) {
  return <GaAddProductsToCartForm {...props} Prev={AddProductsToCartFormBase} />
}
export const AddProductsToCartForm = GaAddProductsToCartFormInterceptor

/**
 * Interceptor for `<ProductListItem/>` with these plugins:
 * 
 * - `@graphcommerce/googleanalytics/plugins/GaProductListItem`
 */
type ProductListItemProps = ComponentProps<typeof ProductListItemBase>

function GaProductListItemInterceptor(props: ProductListItemProps) {
  return <GaProductListItem {...props} Prev={ProductListItemBase} />
}
export const ProductListItem = GaProductListItemInterceptor

/**
 * Interceptor for `<ProductListItemsBase/>` with these plugins:
 * 
 * - `@graphcommerce/googleanalytics/plugins/GaProductListItemsBase`
 */
type ProductListItemsBaseProps = ComponentProps<typeof ProductListItemsBaseBase>

function GaProductListItemsBaseInterceptor(props: ProductListItemsBaseProps) {
  return <GaProductListItemsBase {...props} Prev={ProductListItemsBaseBase} />
}
export const ProductListItemsBase = GaProductListItemsBaseInterceptor

/**
 * Interceptor for `<ProductPageMeta/>` with these plugins:
 * 
 * - `@graphcommerce/googleanalytics/plugins/GaViewItem`
 */
type ProductPageMetaProps = ComponentProps<typeof ProductPageMetaBase>

function GaViewItemInterceptor(props: ProductPageMetaProps) {
  return <GaViewItem {...props} Prev={ProductPageMetaBase} />
}
export const ProductPageMeta = GaViewItemInterceptor
